/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo sliders
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;

    var Widget = kendo.ui.Widget,
        AVATAR = "avatar",
        SLIDER_BUTTONS = "k-slider-buttons",
        ATTR_TITLE = "title",
        ATTR_VAL_UI_TYPE = "valUi",
        widgets = ["Slider", "RangeSlider"];

    /**
     * Tries to get a bool data setting from specified element. The specified
     * original value has precedence when set to true, otherwise the element
     * data is considered when found.
     */
    function boolFromElementData(originalValue, element, dataAttributeName) {
        var $element = $(element),
            result = originalValue || "";
        result = (result.toString().toLowerCase() === "true");
        if (!$element.length) return result;
        var dataValue = $element.data(dataAttributeName) || "";
        dataValue = (dataValue.toString().toLowerCase() === "true");
        return result || dataValue;
    }

    /**
     * By default form reset doesn't reset sliders, so we add it here.
     * Covers also RangeSlider logic with two input values.
     */
    function sliderReset() {
        var self = this,
            $element = self.element,
            $form = $element.closest("form");
        if (!$form[0]) return;
        var $inputs = $element.parent().find("input"),
            $firstInput = $inputs.eq(0),
            $secondInput = $inputs.eq(1);
        self._originalValue = ($inputs.length > 1) ?
            [$firstInput.val(), $secondInput.val()] :
            $firstInput.val();
        self._resetHandler = function () {
            setTimeout(function () {
                self.value(self._originalValue);
                // TODO : self.options.fixedTooltipPosition == "True" here
                // where does it get set ???
                self.info("_reset() - owner : %s", self.owner);
                self.info(
                    "_reset() - fixedTooltipPosition before update : %s",
                    self.options.fixedTooltipPosition
                );
                self.options.fixedTooltipPosition = boolFromElementData(
                    self.options.fixedTooltipPosition, self.element,
                    "fixed-tooltip-position"
                );
                self.info(
                    "_reset() - fixedTooltipPosition : %s",
                    self.options.fixedTooltipPosition
                );
                if (!self.options.fixedTooltipPosition) return;
                if (self._drag)
                    self._drag._updateTooltip(self._originalValue);
                else {
                    self._firstHandleDrag._updateTooltip(self._originalValue);
                    self._lastHandleDrag._updateTooltip(self._originalValue);
                }
            });
        };
        self._form = $form.on("reset", self._resetHandler);
    }

    /**
     * Updated tooltip creation for slider.
     * TODO : Still used ? the HTML inside JS approach is not very nice
     */
    function sliderCreateTooltip() {
        var self = this,
            owner = self.owner,
            tooltip = self.options.tooltip || {},
            html = "";
        if (!tooltip.enabled) return;
        var target = $(owner._trackDiv[0]).parent();
        if (!self.tooltipDiv)
            self.tooltipDiv = $(target[0]).find(".k-slider-tooltip-fixed");
        if (!self.tooltipDiv.length)
            self.tooltipDiv = $("<div class='k-widget k-tooltip k-slider-tooltip-fixed'><!-- --></div>")
                .appendTo(target[0]);
        html = owner._getFormattedValue(self.val || owner.value(), self);
        if (!self.type) {
            self.tooltipInnerDiv = "<div class='k-callout k-callout-" +
                (owner._isHorizontal ? "s" : "e") + "'><!-- --></div>";
            html += self.tooltipInnerDiv;
        }
        self.tooltipDiv.html(html);
    }

    /**
     * Resets one drag handle for a slider with fixed tooltip position.
     */
    function sliderResetDragHandle(handle) {
        if (!handle) return;
        handle._createTooltip = sliderCreateTooltip;
        handle.moveTooltip = $.noop; // nothing to do for fixed tooltip
        handle._removeTooltip = $.noop;
        handle._createTooltip();
    }

    /**
     * Must recalculate the slider track size & drag handle positions
     * after title & validation icons are appended.
     */
    function sliderRecalculateSize() {
        var self = this,
            options = self.options;
        self.info("Recalculating slider size ...");
        self._setTrackDivWidth();
        self._maxSelection = self._trackDiv[self._sizeFn]();
        var sizeBetweenTicks = self._maxSelection / ((options.max - options.min) / options.smallStep),
            pixelWidths = self._calculateItemsWidth(Math.floor(self._distance() / options.smallStep));
        if (options.tickPlacement !== "none" && sizeBetweenTicks >= 2) {
            // self._trackDiv.before( createSliderItems( options, self._distance ) );
            self._setItemsWidth(pixelWidths);
            self._setItemsTitle();
            self._setItemsLargeTick();
        }
        self._calculateSteps(pixelWidths);
        self._refresh();
    }

    /**
     * The original widget "class" gets updated in two steps. First is constructor
     * update. newInit function becomes the new constructor of the component.
     * In the constructor the widget is also republished as kendo plugin, so that
     * jQuery.fn gets updated. Second step is overriding of specific widget methods
     * when needed.
     */
    function updateWidget(widgetName) {
        var widget = kendo.ui[widgetName];
        if (!widget || widget.updated) return;

        var oldWidgetInit = widget.fn.init,
            newWidgetInit = function (element, options) {
                var self = this,
                    $element = $(element);
                // update options from specifically prefixed data on element
                options = kendo.elementOptions($element, widgetName.toLowerCase(), options);
                if (options.enabled === undefined)
                    options.enabled = !$element.is("[disabled]");
                // remove avatar class before the wrapper gets created
                $element.removeClass(AVATAR);
                // we also need to remove identification classes from some
                // widgets' elements, they will be placed on wrapper
                $element.removeClass("k-slider k-slider-horizontal k-slider-vertical");
                // call original constructor
                oldWidgetInit.call(self, element, options);
                // remember title text - needed for various description UI types
                // execute with caution to not remove the title by mistake
                if (self.options.tooltip && self.options.tooltip.enabled === true) {
                    self.options.titleText = self.options.titleText || self.element.attr(ATTR_TITLE);
                }
                self.element.removeAttr(ATTR_TITLE);
                // update validation UI type in options to be sure
                self.options.validationUi = self.options.validationUi || self.element.data(ATTR_VAL_UI_TYPE);
                // move buttons class to main wrapper
                if (self.options.showButtons && self.wrapper) self.wrapper.addClass(SLIDER_BUTTONS);
                // fixed tooltip update
                self.options.fixedTooltipPosition = boolFromElementData(
                    self.options.fixedTooltipPosition, self.element,
                    "fixed-tooltip-position"
                );
                self.info(
                    "init() - fixedTooltipPosition : %s",
                    self.options.fixedTooltipPosition
                );
                if (self.options.fixedTooltipPosition) {
                    if (widgetName === "Slider") {
                        sliderResetDragHandle(self._drag);
                    } else {
                        sliderResetDragHandle(self._firstHandleDrag);
                        sliderResetDragHandle(self._lastHandleDrag);
                    }
                }
                self._reset();
                // update title / tooltip popups
                Widget.fn.descriptionUi.call(self);
                // remove input class from wrapper for easier styling
                self.wrapper.removeClass("k-input");
                // recalculate size when applicable
                self.recalculateSize();
            };

        widget = widget.extend({
            // new init
            init: newWidgetInit,
            // default options extension
            options: kendo.getUpdatedWidgetOptions({ fixedTooltipPosition: false }),
            // updated methods
            _reset: sliderReset,
            recalculateSize: sliderRecalculateSize
        });

        widget.updated = true;

        kendo.ui.plugin(widget);
    }

    // updates to all date / time pickers are the same for now
    for (var i = 0; i < widgets.length; i++)
        updateWidget(widgets[i]);

})(window.kendo.jQuery);
